import {rasterImage} from '../home_media_ui/imageFormats';
export {IMAGE_MIMES, imageMime} from '../home_media_ui/imageFormats';
export const isImage = rasterImage;
export const canViewImage = node => isImage(node) && node.rights?.includes('download');
